angular.module('gym.components').directive('nonAttendingContactDashlets', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/non_attending_contact_dashlets.html.slim'),
    scope: {
      contact: '=',
      convertToMember: '&',
      convertToProspect: '&',
      currency: '&',
      setTab: '&'
    },
    controller: ["$scope", "FeatureAvailabilityService", function($scope, FeatureAvailabilityService) {
      $scope.balance = function() {
        return $scope.contact.balance_dashlet;
      };
      $scope.membership = function() {
        return $scope.contact.membership_dashlet;
      };
      return $scope.creditVouchersAvailable = FeatureAvailabilityService.isAvailable('credit_vouchers');
    }]
  };
});
